@switch (type) {
    @case ('icon') {
        <atom-icon-button
            icon="plus"
            [size]="size"
            [disabled]="disabled"
        ></atom-icon-button>
    }
    @case ('button') {
        <button
            class="btn"
            [attr.data-cy]="cySelector"
            [disabled]="disabled"
            (click)="onClicked($event)"
        >
            <i class="fal fa-plus me-1"></i><ng-content></ng-content>
        </button>
    }
}
